import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Home-screen "pinned" strip. Reads the real, server-backed FavoritePageStaffService favorites
 * list (passed down by app-shell as `favorites`) - not a localStorage store, since the design's
 * mockup "pin" concept was mapped onto the app's existing Favorites feature rather than
 * duplicating it (see redesign plan, Finding 2 / assumption 3).
 *
 * Every card is laid out in view at once - the row auto-fits and reflows to the container width
 * instead of scrolling, so nothing is hidden behind a scrollbar. "See all favorites" swaps the
 * top-10 slice for the user's full list.
 */
@Component({
    selector: 'app-shell-pinned-strip',
    templateUrl: './app-shell-pinned-strip.component.html',
    styleUrls: ['./app-shell-pinned-strip.component.scss'],
})
export class AppShellPinnedStripComponent {
    private static readonly TOP_COUNT = 10;

    @Input() favorites: any[] = [];

    @Output() readonly open = new EventEmitter<any>();
    @Output() readonly unpin = new EventEmitter<{ favorite: any; event: Event }>();

    expanded = false;

    get topCount(): number {
        return AppShellPinnedStripComponent.TOP_COUNT;
    }

    get totalCount(): number {
        return this.favorites.length;
    }

    get shownCount(): number {
        return this.cards.length;
    }

    /** True once the user has more favorites than the strip shows collapsed. */
    get hasMore(): boolean {
        return this.totalCount > AppShellPinnedStripComponent.TOP_COUNT;
    }

    get cards(): any[] {
        return this.expanded ? this.favorites : this.favorites.slice(0, AppShellPinnedStripComponent.TOP_COUNT);
    }

    toggleExpanded(): void {
        this.expanded = !this.expanded;
    }

    onOpen(favorite: any): void {
        this.open.emit(favorite);
    }

    onUnpin(favorite: any, event: Event): void {
        event.stopPropagation();
        this.unpin.emit({ favorite, event });
    }
}
